import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/arvada-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-arvada-colorado",
      statusCode: 301,
    });
  },
});
